// MobileLanguageDropdown.js
import React, { useState, useEffect, useRef } from 'react';
import { MdTranslate } from 'react-icons/md';

import './CustomLanguageDropdown';


const LANGS = [
    { code: '', label: 'Select Language' },

    // Global Popular Languages
    { code: 'en', label: 'English' },
    { code: 'es', label: 'Spanish' },
    { code: 'fr', label: 'French' },
    { code: 'de', label: 'German' },
    { code: 'zh-CN', label: 'Chinese (Simplified)' },
    { code: 'ar', label: 'Arabic' },
    { code: 'pt', label: 'Portuguese' },
    { code: 'ru', label: 'Russian' },
    { code: 'ja', label: 'Japanese' },

    // Indian Popular Languages
    { code: 'hi', label: 'Hindi' },
    { code: 'gu', label: 'Gujarati' },
    { code: 'mr', label: 'Marathi' },
    { code: 'ta', label: 'Tamil' },
    { code: 'te', label: 'Telugu' },
    { code: 'bn', label: 'Bengali' },
    { code: 'ml', label: 'Malayalam' },
    { code: 'kn', label: 'Kannada' },
    { code: 'ur', label: 'Urdu' },
    { code: 'pa', label: 'Punjabi' }
];


const MobileLanguageDropdown = () => {
    const [open, setOpen] = useState(false);
    const ref = useRef();

    const toggleDropdown = () => setOpen(!open);

    const handleLanguageClick = (lang) => {
        const combo = document.querySelector('.goog-te-combo');
        if (combo) {
            combo.value = lang;
            combo.dispatchEvent(new Event('change'));
        } else {
            const u = encodeURIComponent(window.location.href);
            window.location.href = `https://translate.google.com/translate?hl=${lang}&sl=en&u=${u}`;
        }
        setOpen(false);
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="mobile-lang-wrapper" ref={ref}>
            <button className="lang-icon-btn" onClick={toggleDropdown}>
                < MdTranslate />
            </button>

            {open && (
                <div className="custom-lang-dropdown">
                    {LANGS.map(({ code, label }) => (
                        <div
                            key={code}
                            className="custom-lang-option"
                            onClick={() => handleLanguageClick(code)}
                        >
                            {label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MobileLanguageDropdown;
